<!--
Author: TangChen
Date: 2018-09-17
Desc: 我的资产组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-assets-info bizcomp ' + className">
        <comp-title :title="title" />
        <div class="assets-tit border-bot">
            我的资产
            <!--<span class="trade-msg">
        您有<strong>1</strong>笔交易正在确认中
        <el-button type="text" @click="$router.push({name:'traderecord'})">[查看交易记录]</el-button>
      </span>-->
        </div>
        <el-row v-if="$cache.getXjbCode()!==''" class="my-assets">
            <el-col :span="12">
                <div class="assets-info">
                    <div class="chart-box">
                        <!--<pie-chart class="chart" width="200px" height="260px" :data="chartData" :colors="['#e99400', '#008cd4','#48b75f']" :enabled="false" :donut="true" :legend="false" :library="dataSet"></pie-chart>-->
                        <pie-art
                            class="chart"
                            :ref-v="'pie-asset'"
                            style="width: 100%;height: 260px;"
                            :option="chartData"
                            :colors="['#e99400', '#008cd4','#48b75f']"
                        />
                        <div class="assets-all">
                            <p>总资产(元)</p>
                            <span style="letter-spacing: 0;">{{ $util.fmtNum(allAssets.totalasset) }}</span>
                        </div>
                    </div>
                    <div class="assets-detail">
                        <div class="assets-xjb">
                            <span>现金宝(元):</span>
                            <i>{{ $util.fmtNum(allAssets.xjbasset) }}</i>
                        </div>
                        <div class="assets-buy">
                            <span>持有基金(元):</span>
                            <i>{{ $util.fmtNum(allAssets.commonasset) }}</i>
                        </div>
                        <div class="assets-pri">
                            <span>专户理财(元):</span>
                            <i>{{ $util.fmtNum(allAssets.specialasset) }}</i>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="xzb-info">
                    <div class="xzb-msg border-bot">
                        <span class="like-a" v-on:click.once="toPage('mycurrency')"><span class="text">我的现金宝</span><i
                            class="fa fa-chevron-circle-right"
                        /></span>
                    </div>
                    <el-row class="xzb-details">
                        <el-col :span="8">
                            <span>{{ $util.fmtNum(xjbInfo.totalasset) }}</span>
                            <p>
                                账户余额(元)
                                <i class="fa fa-arrow-up" />
                            </p>
                        </el-col>
                        <el-col :span="8">
                            <span :class="xjbInfo.lastincome>0?'add':(xjbInfo.lastincome<0?'reduce':'')">{{ $util.fmtNum(xjbInfo.lastincome) }}</span>
                            <p>昨日收益(元)</p>
                        </el-col>
                        <el-col :span="8">
                            <span :class="xjbInfo.totalincome>0?'add':(xjbInfo.totalincome<0?'reduce':'')">{{ $util.fmtNum(xjbInfo.totalincome) }}</span>
                            <p>累计收益(元)</p>
                        </el-col>
                    </el-row>
                    <el-row class="xzb-btn">
                        <el-col :span="8">
                            <el-button type="yellow" v-on:click="toPage('currencycharge')">
                                <i class="xjb-icon charge" />充值
                            </el-button>
                        </el-col>
                        <el-col :span="8">
                            <el-button type="red" v-on:click="toPage('currencyredemption')">
                                <i class="xjb-icon redemption" />取现
                            </el-button>
                        </el-col>
                        <el-col :span="8">
                            <el-button type="blue" v-on:click="toPage('fund')">
                                <i class="xjb-icon buyFund" />买基金
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <el-row v-else class="cur-info-box">
            <el-col :span="18" class="assets-con">
                <el-col :span="9" class="cur-all">
                    <span class="icon-img" />
                    <div class="icon-info">
                        <span class="amount all">{{ $util.fmtNum(allAssets.commonasset) }}</span>
                        <span class="amount-info">基金总额(元)</span>
                    </div>
                </el-col>
                <el-col :span="7">
                    <span class="icon-img yes" />
                    <div class="icon-info">
                        <span class="amount" :class="allAssets.yestincome>0?'add':(allAssets.yestincome<0?'reduce':'')">{{ $util.fmtNum(allAssets.yestincome) }}</span>
                        <span class="amount-info">昨日收益(元)</span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <span class="icon-img all" />
                    <div class="icon-info">
                        <span class="amount"
                              :class="$cache.getParams().is_zx==1?allAssets.totalincome>0?'add':(allAssets.totalincome<0?'reduce':''):allAssets.totaladdincome>0?'add':(allAssets.totaladdincome<0?'reduce':'')"
                        >{{ $cache.getParams().is_zx=='1'?$util.fmtNum(allAssets.totalincome):$util.fmtNum(allAssets.totaladdincome) }}</span>
                        <span class="amount-info">累计收益(元)</span>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="cur-btn-group other-btn">
                        <!-- <el-button type="text" v-on:click.once="$router.push({name:'fund'})">
                            <i class="xjb-icon detail" />收益明细
                        </el-button> -->
                        <el-button type="text" v-on:click.once="$router.push({name:'traderecord'})">
                            <i
                                class="xjb-icon records"
                            />交易记录
                        </el-button>
                        <el-button type="text" v-on:click.once="$router.push({name:'myplan'})">
                            <i
                                class="xjb-icon my-plan"
                            />我的定投
                        </el-button>
                    </div>
                </el-col>
            </el-col>
            <el-col :span="6" class="others">
                <div class="cur-btn-group btn-xjb">
                    <div>
                        <el-button type="orange" v-on:click.once="$router.push({name:'fund'})">
                            <i class="xjb-icon charge" />我要买基金<i
                                class="el-icon-arrow-right el-icon--right"
                            />
                        </el-button>
                    </div>
                    <div>
                        <el-button type="red" v-on:click.once="$router.push({name:'cfund'})">
                            <i class="xjb-icon redemption" />基金转换<i
                                class="el-icon-arrow-right el-icon--right"
                            />
                        </el-button>
                    </div>
                    <div>
                        <el-button type="blue" v-on:click.once="$router.push({name:'gfund'})">
                            <i class="xjb-icon general" />我要定投<i
                                class="el-icon-arrow-right el-icon--right"
                            />
                        </el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import pieArt from "@/components/misc/pieArt";
export default {
    name: "AssetsInfo",
    components: {
        pieArt
    },
    mixins: [mixin],
    data () {
        return {
            dataSet: { // options选项配置
                cutoutPercentage: 80, // 甜甜圈图形内径占有整个图形的比例
                tooltips: {
                    enabled: false // 不显示提示
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                }
            },
            allAssets: {},
            xjbInfo: {},
            userType: "",
            chartData: [{ name: "现金宝", value: 0 }, { name: "持有基金", value: 0 }, { name: "私募产品", value: 0 }]
        };
    },
    created () {
        const info = this.$cache.getUser();
        this.getAll();
        if(this.$cache.getXjbCode() !== ""){
            this.getXjbInfo();
        }
        if (info) {
            this.userType = info.usertype;
        }
    },
    methods: {
        toPage (val) {
            if (val === "myxjb" && (this.userType !== "3" && this.userType !== "4")) {
                val = "currencyfund";
            }
            this.$router.push({ name: val });
        },
        getAll () {
            const _this = this;
            this.$util.request("acct/asset/total").then(res => {
                if (res.data) {
                    if (res.data[0] && res.data[0][0]) {
                        _this.allAssets = res.data[0][0];
                    } else {
                        _this.allAssets = res.data[0] ? res.data[0] : {};
                    }
                    _this.chartData = [{ name: "现金宝", value: _this.allAssets.xjbasset }, { name: "持有基金", value: _this.allAssets.commonasset }, { name: "私募产品", value: _this.allAssets.specialasset }];
                }
            });
        },
        // 获取现金宝信息
        getXjbInfo () {
            this.$util.request("xjb/query/asset").then(res => {
                if (res.data) {
                    this.xjbInfo = res.data[0];
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-assets-info {
    .cur-info-box .el-col .other-btn {
        .el-button + .el-button {
            margin-left: 60px;
        }
        .el-button {
            font-size: $f14;
            i {
                &.detail {
                    background: url($icon) -370px -226px no-repeat;
                }
                &.my-plan {
                    background: url($icon) -369px -260px no-repeat;
                }
            }
        }
        padding-left: 20px;
        text-align: left;
    }
}
</style>
